import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CloseIcon from "@mui/icons-material/Close";
import ReplyIcon from "@mui/icons-material/Reply";
import { IconButton } from "@mui/material";
import { TWhiteboardMessage } from "protico-sdk";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import useBasicProfile from "../../../hooks/useBasicProfile";
import { useWhiteboardRoom } from "../../../hooks/useWhiteboardRoom";
import { useBToCWebsocket } from "../../../hooks/useBtoCWebsocket";
import { setNext, setPrevious } from "../../../store/reducers/whiteboard";
import { getProticoClient } from "../../../utils/api";
import { isAssetUrl, isListUrl } from "../../../utils/format.utils";
import ReferenceHeader from "./ReferenceHeader";
import "./index.css";
const BToCFloatPlugin = () => {
  const {
    displayLatestMessage,
    handleSetShouldScrollToBottom,
    nextReference,
    handleSetNextReference,
    isLatestMessageExist,
    handleSetMessageList,
  } = useBToCWebsocket();
  const { basicProfile: latestMessageProfile } = useBasicProfile(
    displayLatestMessage?.sender_meta?.address
  );
  const { basicProfile: nextReferenceProfile } = useBasicProfile(
    nextReference?.sender_address
  );
  const { room } = useWhiteboardRoom();
  const dispatch = useAppDispatch();
  const { isScrollAbove } = useAppSelector((state) => state.whiteboard);
  const { currentAddress } = useAppSelector((state) => state.auth);
  const { t } = useTranslation();

  const fetchData = async () => {
    let messages: TWhiteboardMessage[] = [];
    try {
      const response = await getProticoClient().whiteboard.getMessages({
        room,
        address: currentAddress,
      });
      messages = response.data.results;
      if (messages.length !== 0) {
        dispatch(
          setNext({
            id: messages[0].id,
            createdAt: messages[0].createdAt,
            url: response.data.next,
          })
        );
        dispatch(
          setPrevious({
            id: messages[messages.length - 1].id,
            createdAt: messages[messages.length - 1].createdAt,
            url: response.data.previous,
          })
        );
      }
    } catch (err) {}
    handleSetMessageList(messages);
  };

  const onClickJumpto = async () => {
    await fetchData();
    handleSetShouldScrollToBottom();
  };

  const onClickCloseReference = () => {
    handleSetNextReference(null);
  };

  return (
    <div className="whiteBoard-float-container">
      {!!displayLatestMessage && latestMessageProfile && (
        <div className="whiteBoard-jumpto-content" onClick={onClickJumpto}>
          {latestMessageProfile.name}:{" "}
          {isAssetUrl(displayLatestMessage.messageText) ||
          isListUrl(displayLatestMessage.messageText)
            ? t("Message_Item_Refer_Image")
            : displayLatestMessage.messageText}
        </div>
      )}
      {(isScrollAbove || !isLatestMessageExist) && (
        <span
          className="whiteBoard-jumpto-float-button"
          onClick={onClickJumpto}
        >
          <ArrowDownwardIcon fontSize="small" />
        </span>
      )}
      {!!nextReference && nextReferenceProfile && (
        <div className="whiteBoard-reference-container">
          <span className="whiteBoard-reference-reply-icon-container">
            <ReplyIcon style={{ color: "#fff" }} fontSize="small" />
          </span>
          <div className="whiteBoard-reference-content">
            <ReferenceHeader address={nextReference?.sender_address} />
            <p>{nextReference.messageText}</p>
          </div>

          <span className="whiteBoard-reference-close-button">
            <IconButton onClick={onClickCloseReference}>
              <CloseIcon style={{ opacity: "0.5" }} fontSize="small" />
            </IconButton>
          </span>
        </div>
      )}
    </div>
  );
};
export default BToCFloatPlugin;
